export default "__VITE_ASSET__Bj4xgGlc__"